import { Box, Button, MenuItem } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { TagType } from "../../constants";
import {
  COACH_CLIENTS_TAGS_ROUTE,
  COACH_EXERCISE_LIBRARY_TAGS_ROUTE,
} from "../../routes/routes";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  footer: {
    padding: theme.spacing(1, 2),
    fontSize: 14,
    color: theme.palette.primary.main,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}));

interface TagMultiSelectFooterProps {
  onClick?: () => void;
  tagType: TagType;
  isTagsExisting?: boolean;
}

const TagMultiSelectFooter = (props: TagMultiSelectFooterProps) => {
  const { onClick, isTagsExisting, tagType } = props;

  const s = useStyles();

  const navigate = useNavigate();

  let redirectLink;

  switch (tagType) {
    case TagType.EXERCISE:
      redirectLink = COACH_EXERCISE_LIBRARY_TAGS_ROUTE;
      break;
    case TagType.CLIENT:
      redirectLink = COACH_CLIENTS_TAGS_ROUTE;
      break;
    default:
      throw new Error(`Unsupported tag type: ${tagType}`);
  }

  return (
    <MenuItem key="footer" className={s.footer} onClick={onClick}>
      <Box onClick={() => navigate(redirectLink)}>
        {isTagsExisting ? "Manage tags" : "+ Add new tag"}
      </Box>
    </MenuItem>
  );
};

export default TagMultiSelectFooter;
